import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Users, BadgeCheck } from 'lucide-react';

// Production-safe API host: same-origin in deployed builds, env var in preview.
const _ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const _ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
const _isPreviewEnv = /preview\.emergentagent\.com$/.test(
  (typeof window !== 'undefined' && window.location.hostname) || ''
);
const API = _isPreviewEnv ? _ENV_BACKEND : (_ORIGIN || _ENV_BACKEND);

const MembershipDirectory = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/membership/directory`)
      .then((r) => r.json())
      .then((d) => setMembers(d.members || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', color: '#e2e8f0' }}>
      <div style={{ padding: '20px 40px', display: 'flex', gap: 20 }}>
        <Link to="/" style={{ display: 'inline-flex', gap: 8, color: '#cbd5e1', textDecoration: 'none' }}>
          <ArrowLeft size={18} /> Home
        </Link>
        <Link to="/association" style={{ marginLeft: 'auto', color: '#5eead4', textDecoration: 'none' }}>About the Association</Link>
      </div>
      <section style={{ maxWidth: 1000, margin: '0 auto', padding: '40px 40px 60px' }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <Users size={42} color="#5eead4" />
          <h1 style={{ fontSize: '2rem', color: '#f8fafc', marginTop: 14 }}>Member Directory</h1>
          <p style={{ color: '#94a3b8', maxWidth: 580, margin: '12px auto 0' }}>
            Active members of the MedCare National Board of Nursing &amp; the Vital Health Sciences Association.
          </p>
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: 40 }}>Loading directory…</div>
        ) : members.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: 40, background: 'rgba(255,255,255,0.04)', borderRadius: 12 }}>No members yet — be the first!</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 14 }}>
            {members.map((m) => (
              <div key={m.member_number} data-testid={`directory-member-${m.member_number}`} style={{ background: 'rgba(255,255,255,0.04)', padding: 18, borderRadius: 12, border: '1px solid rgba(255,255,255,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <BadgeCheck size={20} color="#34d399" />
                  <span style={{ fontSize: '0.75rem', color: '#5eead4', letterSpacing: 1 }}>{m.member_number}</span>
                </div>
                <div style={{ color: '#f8fafc', fontWeight: 700 }}>{m.full_name || 'Member'}</div>
                {m.specialty && <div style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: 4 }}>{m.specialty}</div>}
                {(m.city || m.state) && <div style={{ color: '#64748b', fontSize: '0.8rem', marginTop: 2 }}>{[m.city, m.state].filter(Boolean).join(', ')}</div>}
                <div style={{ color: '#64748b', fontSize: '0.75rem', marginTop: 6 }}>Joined {(m.joined_date || '').split('T')[0]}</div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default MembershipDirectory;
